module.exports = __webpack_public_path__ + "static/media/close-grey.86d01b58.svg";